/**
 * What an amendment or a bill-to refresh can move: any invoice it reached (its
 * details, the lists and search showing it, its bill-to history) and the
 * offer's installment schedule.
 */
export function amendedQueryKeys(
  offerId?: number | null,
): (readonly unknown[])[] {
  return [
    ['invoices'],
    ...(offerId
      ? [
          ['offers', 'split-state', offerId] as const,
          ['split-plan', offerId] as const,
        ]
      : []),
  ];
}
